import { call, put } from 'redux-saga/effects';
import { photoCaptureDataFailureAction, photoCaptureGetFoldersSuccessAction } from '../actions';
import { PhotoCaptureFoldersService } from '../services';
import { getErrorMessagesBasedOnStatusCode } from '../utilities';
export function* photoCaptureGetFoldersSaga(action, photoCaptureGetFoldersService = new PhotoCaptureFoldersService()) {
    const { coCode, contextId } = action.payload;
    try {
        const response = yield call({ context: photoCaptureGetFoldersService, fn: photoCaptureGetFoldersService.photoCaptureGetFolders }, coCode, contextId);
        yield put(photoCaptureGetFoldersSuccessAction(response));
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        yield put(photoCaptureDataFailureAction(errorMessage));
    }
}
//# sourceMappingURL=photoCaptureGetFoldersSaga.js.map